import { render, staticRenderFns } from "./PracticalExamCreate.vue?vue&type=template&id=357c57f7&"
import script from "./PracticalExamCreate.vue?vue&type=script&lang=ts&"
export * from "./PracticalExamCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports